import { render, staticRenderFns } from "./ResponsibleView.vue?vue&type=template&id=44530cb6&scoped=true"
import script from "./ResponsibleView.vue?vue&type=script&lang=js"
export * from "./ResponsibleView.vue?vue&type=script&lang=js"
import style0 from "./ResponsibleView.vue?vue&type=style&index=0&id=44530cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44530cb6",
  null
  
)

export default component.exports